export const currenciesEn = {
  AED: 'UAE Dirham',
  AFN: 'Afghani',
  ALL: 'Lek',
  AMD: 'Armenian Dram',
  AOA: 'Kwanza',
  ARS: 'Argentine Peso',
  AUD: 'Australian Dollar',
  AWG: 'Aruban Guilder',
  AZN: 'Azerbaijanian Manat',
  BAM: 'Convertible Marks',
  BBD: 'Barbados Dollar',
  BDT: 'Taka',
  BGN: 'Bulgarian Lev',
  BHD: 'Bahraini Dinar',
  BIF: 'Burundi Franc',
  BMD: 'Bermudian Dollar',
  BND: 'Brunei Dollar',
  BOB: 'Boliviano',
  BRL: 'Brazilian Real',
  BSD: 'Bahamian Dollar',
  BTN: 'Ngultrum',
  BWP: 'Pula',
  BYR: 'Belarussian Ruble',
  BZD: 'Belize Dollar',
  CAD: 'Canadian Dollar',
  CDF: 'Franc Congolais',
  CHF: 'Swiss Franc',
  CLP: 'Chilean Peso',
  CNY: 'Yuan Renminbi',
  COP: 'Colombian Peso',
  CRC: 'Costa Rican Colon',
  CUC: 'Cuban Convertible Peso',
  CUP: 'Cuban Peso',
  CVE: 'Cape Verde Escudo',
  CZK: 'Czech Koruna',
  DJF: 'Djibouti Franc',
  DKK: 'Danish Krone',
  DOP: 'Dominican Peso',
  DZD: 'Algerian Dinar',
  EGP: 'Egyptian Pound',
  EUR: 'Euro',
  ERN: 'Nakfa',
  ETB: 'Ethiopian Birr',
  FJD: 'Fiji Dollar',
  FKP: 'Falkland Islands Pound',
  GBP: 'Pound Sterling',
  GEL: 'Lari',
  GHS: 'Cedi',
  GIP: 'Gibraltar Pound',
  GMD: 'Dalasi',
  GNF: 'Guinea Franc',
  GTQ: 'Quetzal',
  GYD: 'Guyana Dollar',
  HKD: 'Hong Kong Dollar',
  HNL: 'Lempira',
  HRK: 'Croatian Kuna',
  HTG: 'Gourde',
  HUF: 'Forint',
  IDR: 'Rupiah',
  ILS: 'New Israeli Sheqel',
  INR: 'Indian Rupee',
  IQD: 'Iraqi Dinar',
  IRR: 'Iranian Rial',
  ISK: 'Iceland Krona',
  JMD: 'Jamaican Dollar',
  JOD: 'Jordanian Dinar',
  JPY: 'Yen',
  KES: 'Kenyan Shilling',
  KGS: 'Som',
  KHR: 'Riel',
  KMF: 'Comoro Franc',
  KPW: 'North Korean Won',
  KRW: 'Won',
  KWD: 'Kuwaiti Dinar',
  KYD: 'Cayman Islands Dollar',
  KZT: 'Tenge',
  LAK: 'Kip',
  LBP: 'Lebanese Pound',
  LKR: 'Sri Lankan Rupee',
  LRD: 'Liberian Dollar',
  LSL: 'Loti',
  LYD: 'Libyan Dinar',
  MAD: 'Moroccan Dirham',
  MDL: 'Moldovan Leu',
  MGA: 'Malagasy Ariary',
  MKD: 'Denar',
  MMK: 'Kyat',
  MNT: 'Tugrik',
  MOP: 'Pataca',
  MRO: 'Ouguiya',
  MUR: 'Mauritius Rupee',
  MVR: 'Rufiyaa',
  MWK: 'Kwacha',
  MXN: 'Mexican Peso',
  MYR: 'Malaysian Ringgit',
  MZN: 'Merical',
  NAD: 'Namibian Dollar',
  NGN: 'Naira',
  NIO: 'Cordoba Oro',
  NOK: 'Norwegian Krone',
  NPR: 'Nepalese Rupee',
  NZD: 'New Zealand Dollar',
  OMR: 'Rial Omani',
  PAB: 'Balboa',
  PEN: 'Nuevo Sol',
  PGK: 'Kina',
  PHP: 'Philippine Peso',
  PKR: 'Pakistan Rupee',
  PLN: 'Zloty',
  PYG: 'Guaraní',
  QAR: 'Qatari Rial',
  RON: 'New Leu',
  RSD: 'Serbian dinar',
  RUB: 'Russian Ruble',
  RWF: 'Rwanda Franc',
  SAR: 'Saudi Riyal',
  SBD: 'Solomon Islands Dollar',
  SCR: 'Seychelles Rupee',
  SDG: 'Sudanese Dinar',
  SEK: 'Swedish Krona',
  SGD: 'Singapore Dollar',
  SHP: 'Saint Helena Pound',
  SLL: 'Leone',
  SOS: 'Somali Shilling',
  SRD: 'Surinam Dolla',
  SSP: 'Southsudanese Pound',
  STD: 'Dobra',
  SYP: 'Syrian pound',
  SZL: 'Lilangeni',
  THB: 'Baht',
  TJS: 'Somoni',
  TMM: 'Manat',
  TND: 'Tunisian Dinar',
  TOP: "Pa'anga",
  TRY: 'new Turkish Lira',
  TTD: 'Trinidad and Tobago Dollar',
  TWD: 'New Taiwan dollar',
  TZS: 'Tanzanian Shilling',
  UAH: 'Hryvnia',
  UGX: 'Uganda Shilling',
  USD: 'US dollar',
  UYU: 'Peso Uruguayo',
  UZS: 'Uzbekistan Sum',
  VEF: 'Bolivar',
  VND: 'Dong',
  VUV: 'Vatu',
  WST: 'Tala',
  YER: 'Yemeni Rial',
  ZAR: 'Rand',
  ZMW: 'Kwacha',
  ZWL: 'Zimbabwe Dollar',
  ANG: '',
} as const;
